import React, {Component} from 'react';
import FilterFrame from './FilterFrame.js';
import './App.css';

class App extends Component{
    constructor(props) {
        super(props);
        this.state = {
                  data: null,
        };
    }

    componentDidMount() {
        fetch("https://www.thebridgeagents.com/open-roles")
              .then(response => response.json())
            .then((jsonData) => {
                this.setState({data : jsonData});
            })
            .catch((error) => {
                     console.error(error);
            })
    }

    render(){
        if(this.state.data){
            return (<FilterFrame data = {this.state.data}></FilterFrame>);
        }  else{
            return(<div id="infoText"><p>Loading...</p></div>)
        }

    }
}
export default App;
